module.exports = __webpack_public_path__ + "files/6eb6774e390de11e2d767062625467b1.png";